<app-loader *ngIf="isDisabled"></app-loader>
<div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Company Document
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col" style="width: 5px;">#</th>
                        <th style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsView}">View</th>
                        <th>Policy Name</th>
                        <th style="width: 100px;">Policy Type</th>
                        <th style="width: 80px;">Valid Till</th>
                        <th style="width: 150px;">Last Update Date</th>
                        <th>Description</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let TableData of TableDatas; let i = index">
                        <th scope="row" style="width: 5px;">{{i+1}}</th>
                        <td style="width: 40px;" [ngClass]="{'colHide': !this.common.PageRight.IsView}">
                            <div class="text-center" style="width: 80px;">
                                <button type="button" class="btn btn-outline-primary btn-sm"
                                    style="font-size: 0.75rem; padding: 0.25rem 0.5rem;" (click)="LinkInTab(TableData)">
                                    <i *ngIf="TableData['IsTrainingVideo']" class="bi bi-play-circle me-1"></i>
                                    <i *ngIf="!TableData['IsTrainingVideo']" class="bi bi-info-square me-1"></i>
                                    View
                                </button>
                            </div>
                        </td>
                        <td>{{TableData['ESS_CompanyPolicyTitle']}}
                            <img *ngIf="TableData['Icon'] != null && TableData['Icon'] != ''" mat-card-image
                                class="userImage small-icon" [src]="TableData['Icon']" />
                        </td>
                        <td style="width: 100px;">{{TableData['ESS_CompanyPolicyTypeTitle']}}</td>
                        <td style="width: 10px;">{{TableData['ValidTillDate']}}</td>
                        <td style="width: 50px;">{{TableData['LastUpdatedDate']}}</td>
                        <td style="width: 10px;">{{TableData['Description']}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<!-- <iframe width="100%" height="100%" frameBorder="0" src="https://webftp.maxus.co.in/PROD/CompanyDocument/Dec-2024/20241203162648215.png"></iframe> -->